import { render, staticRenderFns } from "./flowVoucherComponent.vue?vue&type=template&id=238a9d49&scoped=true&"
import script from "./flowVoucherComponent.vue?vue&type=script&lang=js&"
export * from "./flowVoucherComponent.vue?vue&type=script&lang=js&"
import style0 from "./flowVoucherComponent.vue?vue&type=style&index=0&id=238a9d49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238a9d49",
  null
  
)

export default component.exports